import { Injectable } from '@angular/core';
import { CreatePfacModel, PfacModel } from '../models/configuration-pfac.models';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { SearchPfacModel, UpdatePfacModel } from '../models/configuration-pfac.models';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationPfacService {

  constructor(private http: HttpClient) { }

  save(data: CreatePfacModel): Observable<any> {
    return this.http.post<PfacModel>(`${environment.apiUrls.pfac}`, data);
  }

  getAllPageable(filtro: SearchPfacModel): Observable<any> {    
    return this.http.get(`${environment.apiUrls.pfac}/pageable?page=${filtro.pageNumber}&size=${filtro.size}`);
  }

  update(id: number, data: UpdatePfacModel): Observable<any> {
    return this.http.post<PfacModel>(`${environment.apiUrls.pfac}/${id}/update`, data);
  }

  getAllAudit(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrls.pfac}/${id}/audit`);
  }

}
